import React, { Component } from 'react';
import { RESTExecutor, withDomains } from '../../lib/domain';
import { Spin, Alert } from 'antd';
import ErrorWrapper from '../../lib/error_wrapper';
import SmallTableView from '../../components/dashboard/small_table_view';
import Title from 'antd/lib/typography/Title';
import DashboardLineChart from '../../components/dashboard/line_chart';
import { showErrorInNotification } from '../../lib/util';
import DashboardIconCard from '../../components/dashboard/dashboard_icon_card';

class DashboardTabPage extends Component {
    constructor(props) {
        super(props)
        this.tab_id = props.match.params.tab_id

        this.state = {
            loading: true,
            widget_detail: {}
        }
        this.get_dashboarddata = RESTExecutor.detail().config({
            label: 'tab_data'
        }).forId(this.tab_id).callbacks((success) => {
            console.log("success", success)
            this.setState({
                loading: false,
                widget_detail: success.result
            })
        }, (error) => {
            this.setState({
                loading: false
            });
            showErrorInNotification(error);
        }).connect(props.domains.dashboard);

        this.get_dashboarddata.execute()
    }

    _renderWidget = (type, item) => {

        switch (type) {
            case "TABLE":
                return <SmallTableView data={item} />

            case "LINE":
                return <DashboardLineChart data={item} />

            case "ICONCARD":
                return <DashboardIconCard data={item} />
            default:

                return <div>Cannot find renderer for {type}. Please contact developer for the change</div>
        }
    }

    _renderWidget2 = (widget) => {
        if (Array.isArray(widget.children)) {
            return <div style={{
                margin: 8,
            }}>
                <Title underline level={3} style={{ margin: 0, marginBottom: 8 }} type='secondary'>{widget.title}</Title>
                <div style={{
                    display: 'flex',
                    flexDirection: widget.direction || "row",
                    alignItems:'center',
                    // margin:8

                }}>
                    {widget.children.map((item) => {
                        return this._renderWidget2(item)
                    })}
                </div>
            </div>
        }
        else {
            switch (widget.widget_type) {
                case "TABLE":
                    return <div style={{
                        flex:1,margin:8
                    }}>
                        <Title underline level={3} style={{ margin: 0, marginBottom: 6 }} type='secondary'>{widget.widget_title}</Title>
                        <SmallTableView data={widget} />
                    </div>


                case "LINE":
                    return <div style={{
                        flex:1,margin:8
                    }}>
                        <Title underline level={3} style={{ margin: 0, marginBottom: 6 }} type='secondary'>{widget.widget_title}</Title>
                        <DashboardLineChart data={widget} />
                    </div>

                case "ICONCARD":
                    return <div style={{
                        flex:1,margin:8
                    }}>
                        <Title underline level={3} style={{ margin: 0, marginBottom: 6 }} type='secondary'>{widget.widget_title}</Title>
                        <DashboardIconCard data={widget} />
                    </div>
                default:

                    return <div style={{
                        flex:1,margin:8
                    }}>
                        <Title underline level={3} style={{ margin: 0, marginBottom: 6 }} type='secondary'>{widget.widget_title}</Title>
                        <div>Cannot find renderer for {widget.type}. Please contact developer for the change</div>
                    </div>
            }
        }
    }

    render() {
        const { loading } = this.state;
        if (loading) {
            return <center><Spin /></center>
        }
        let get_dashboarddata_resp = this.get_dashboarddata.response();
        const { widget_detail } = this.state;
        let widget_list = widget_detail.widgets || [];
        console.log("widget list", widget_list)
        return (
            <ErrorWrapper
                error={get_dashboarddata_resp}
                no_back_action
                onReload={() => {
                    this.setState({ loading: true })
                    this.get_dashboarddata.execute();
                }}
            >
                <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                }}>
                    <Alert
                        style={{ margin: 8 }}
                        message={widget_detail.title}
                        description={widget_detail.description}
                        type="info"
                    />

                    {widget_list.map((row_array, rowIndex) => {
                        return <div key={rowIndex} style={{
                            display: 'flex',
                            flexDirection: 'row',
                            flexWrap: 'nowrap',
                            margin: 0,
                        }}>
                            {row_array.map((widget_item, widgetIndex) => {
                                return <div key={widgetIndex}
                                    // className='default-card' 
                                    style={{
                                        flex: 1,
                                        // padding: 4,
                                        minWidth: 200,
                                        // margin: 8
                                    }}>
                                    {/* <Title underline level={3} style={{ margin: 0, marginBottom: 8 }} type='secondary'>{widget_item.widget_title}</Title> */}
                                    {this._renderWidget2(widget_item)}
                                </div>
                            })}

                        </div>
                    })}
                </div>
            </ErrorWrapper>
        );
    }

    componentDidUpdate = (prevProps) => {
        if (this.props.match.params.tab_id !== prevProps.match.params.tab_id) {
            this.tab_id = this.props.match.params.tab_id;
            this.setState({
                loading: true,
            })
            this.get_dashboarddata.forId(this.tab_id).execute()
        };
    };
}

export default withDomains(DashboardTabPage, "dashboard");